module.exports = __webpack_public_path__ + "assets_1773307907123/img/guide_android.4b8e8721.png";